import { removeNamespace } from "../../utils/helpers"
import $http from "@/plugins/axios"

export const EXAM_COPY_REQUESTS_TYPES = {
  mutations: {
    SET_LOADING: "examCopyRequests/SET_LOADING",
    SET_PAGED_REQUESTS: "examCopyRequests/SET_PAGED_REQUESTS",
    SET_REQUESTS_COUNT: "examCopyRequests/SET_REQUEST_COUNT",
    SET_REQUEST_TABLE_OPTIONS: "examCopyRequests/SET_REQUEST_TABLE_OPTIONS",
    SET_KEYWORD: "examCopyRequests/SET_KEYWORD",
    SET_STARTDATE: "examCopyRequests/SET_STARTDATE",
    SET_ENDDATE: "examCopyRequests/SET_ENDDATE",
    SET_SEARCH_TYPE: "examCopyRequests/SET_SEARCH_TYPE",
    RESET: "examCopyRequests/RESET",
    SET_STATUS: "examCopyRequests/SET_STATUS",
    RESET_STATUS: "examCopyRequest/RESET_STATUS"
  },
  actions: {
    fetchRequestsPaged: "examCopyRequests/fetchRequestsPaged",
    updateSearchType: "examCopyRequests/updateSearchType",
    search: "examCopyRequests/search",
    setDateRange: "examCopyRequests/setDateRange",
    statusFilter: "examCopyRequests/statusFilter"
  }
}

const _types = removeNamespace(
  "examCopyRequests",
  EXAM_COPY_REQUESTS_TYPES
)

const state = () => ({
  loading: false,
  requestTableOptions: {
    page: 1,
    itemsPerPage: 10,
    keyword: "",
    searchType: "Name",
    orderBy: null,
    orderDescending: false,
    startDate: "",
    endDate: "",
    statuses: []
  },
  rawTableOptions: null,
  pagedRequests: [],
  requestsCount: 0
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_REQUESTS] (state, pagedRequests) {
    state.pagedRequests = pagedRequests
  },
  [_types.mutations.SET_REQUESTS_COUNT] (state, count) {
    state.requestsCount = count
  },
  [_types.mutations.SET_STATUS] (state, statuses) {
    state.requestTableOptions.statuses = [...state.requestTableOptions.statuses, ...statuses]
  },
  [_types.mutations.SET_REQUEST_TABLE_OPTIONS] (state, tableOptions) {
    state.rawTableOptions = tableOptions

    tableOptions.endDate = state.requestTableOptions.endDate
    tableOptions.startDate = state.requestTableOptions.startDate
    tableOptions.statuses = [ ...state.requestTableOptions.statuses]
    const { page, itemsPerPage, keyword, startDate, endDate, statuses } = tableOptions

    state.requestTableOptions = {
      ...state.requestTableOptions,
      page,
      itemsPerPage,
      keyword,
      startDate,
      endDate,
      statuses,
      orderBy: tableOptions.sortBy.length > 0 ? tableOptions.sortBy[0] : null,
      orderDescending:
        tableOptions.sortDesc.length > 0 ? tableOptions.sortDesc[0] : null
    }
  },
  [_types.mutations.SET_KEYWORD] (state, keyword) {
    state.requestTableOptions.keyword = keyword
  },
  [_types.mutations.SET_STARTDATE] (state, startDate) {
    state.requestTableOptions.startDate = startDate
  },
  [_types.mutations.SET_ENDDATE] (state, endDate) {
    state.requestTableOptions.endDate = endDate
  },

  [_types.mutations.RESET_STATUS] (state) {
    state.requestTableOptions.statuses = []
  },
  [_types.mutations.RESET] (state) {
    state.requestTableOptions = {
      ...state.requestTableOptions,
      page: 1,
      itemsPerPage: 10,
      keyword: "",
      orderBy: null,
      startDate: "",
      endDate: "",
      statuses: [],
      orderDescending: false
    }
  },
  [_types.mutations.SET_SEARCH_TYPE] (state, type) {
    state.requestTableOptions.searchType = type
  }
}

const actions = {
  [_types.actions.fetchRequestsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const {
      itemsPerPage,
      page,
      keyword,
      orderBy,
      orderDescending,
      searchType,
      startDate,
      endDate,
      statuses
    } = state.requestTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return $http()
      .get("admin/EvaluationCopyRequest/EvaluationCopyRequestPaged", {
        params: {
          skipCount,
          maxResultCount,
          searchType,
          keyword,
          orderBy,
          startDate,
          endDate,
          statuses,
          orderDescending: orderDescending ?? false
        }
      })
      .then(res => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_REQUESTS, items)
        commit(_types.mutations.SET_REQUESTS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.search] ({ state, commit, dispatch }, payload) {
    // commit(_types.mutations.RESET)
    commit(_types.mutations.SET_KEYWORD, payload)
    dispatch(_types.actions.fetchRequestsPaged)
  },
  [_types.actions.setDateRange] ({ commit, dispatch }, { startDate, endDate }) {
    commit(_types.mutations.SET_STARTDATE, startDate)
    commit(_types.mutations.SET_ENDDATE, endDate)
    dispatch(_types.actions.fetchRequestsPaged)
  },

  [_types.actions.statusFilter] ({ commit, dispatch }, payload) {
    commit(_types.mutations.RESET_STATUS)
    commit(_types.mutations.SET_STATUS, payload)
    dispatch(_types.actions.fetchRequestsPaged)
  },

  [_types.actions.updateSearchType] ({ commit, dispatch }, payload) {
    commit(_types.mutations.SET_SEARCH_TYPE, payload)
    dispatch(_types.actions.fetchRequestsPaged)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
